import { RootState } from "../store";
export const selectSpecialties = (state: RootState) =>
  state.specialties.specialties;
